import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Injector,
    Input,
    OnDestroy,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';
import { IUserProfile } from '@fi-shared/profile-icon/profile-icon.component';
import { FiInfiniteScrollDataSource, TSortOrder } from '@fi-shared/fi-items-list/fi-infinite-scroll-data-source';
import { FiItemsListType } from '@fi-shared/fi-items-list/fi-items-list-type';
import { ObjectTypes } from '@fi-shared/types';
import { IOnboardingAssignee } from '@fi-app/fi-onboarding/fi-onboarding-synchronized/fi-onboarding-synchronized';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'fi-onboarding-master-user-assignees',
    templateUrl: './fi-onboarding-master-user-assignees.component.html',
    styleUrl: './fi-onboarding-master-user-assignees.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-onboarding-master-user-assignees' },
    standalone: false,
})
export class FiOnboardingMasterUserAssigneesComponent
    extends FiInfiniteScrollDataSource<IUserProfile>
    implements OnInit, OnDestroy
{
    @Input({ required: true }) masterUsers: IUserProfile[];
    @Input({ required: true }) onboardingAssignees: IOnboardingAssignee[];
    @Input({ required: true }) onboardingAssigneesChanged$: Observable<void>;

    itemsListType = FiItemsListType.OnboardingMasterUserAssigneesList;
    objectType = ObjectTypes.Onboarding;
    protected readonly UserColumnName = 'Name';

    constructor(injector: Injector) {
        super(injector);
    }

    ngOnInit(): void {
        this.reloadData();
        this.onboardingAssigneesChanged$.pipe(takeUntil(this.ngOnDestroy$)).subscribe(() => {
            this.cdr.markForCheck();
        });
    }

    getListData(): Promise<IUserProfile[]> {
        return Promise.resolve(this.masterUsers);
    }

    protected getSortOrderFn(): TSortOrder<IUserProfile> {
        if (this.selectedSort.active === this.UserColumnName) return this.getUserNameSort.bind(this);

        return super.getSortOrderFn();
    }

    private getUserNameSort(item: IUserProfile): string {
        return item.FullName;
    }

    protected getAssignedUsersCount(masterUser: IUserProfile): string {
        const cnt = this.onboardingAssignees.filter((assignee) => assignee.MasterUserId === masterUser.Id).length;
        return cnt > 0 ? cnt.toString() : '-';
    }
}
